import '@angular/localize/init';
export * from './lib/feature-tax-uitstel-list.module';

export * from './lib/tax-uitstel-list/feature-tax-uitstel-list.component';
